// extracted by mini-css-extract-plugin
export default {"container":"D6EWxu","title":"CBFwZ7","content":"OQJecu","image":"VDz3NN"};